<template>
    <payment-intents-find
        :params="{
            payment_intent: $route.params.payment_intent
        }"
        :include="[
            'charge(include:subscriptions)'
        ]"
        v-slot="{
            sid,
            data: payment_intent,
            error,
            is_loading,
            has_loaded,
            find
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="find"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <template v-else>
            <div>
                <with-dimensions
                    v-slot="{
                        width
                    }"
                    v-if="payment_intent.charge.state === 'unconfirmed'"
                >
                    <base-form @submit="onSubmit(payment_intent)">
                        <div class="relative mb-6 bg-white rounded shadow pt-1-5">
                            <div class="absolute inset-x-0 top-0 rounded-t bg-red h-1-5" />

                            <div
                                :class="width > 500 ? 'p-6' : 'p-3'"
                                class="flex w-full border-b"
                            >
                                <base-svg
                                    name="icon-important-circle-large"
                                    :class="width > 500 ? 'w-8 h-8 mr-4' : 'w-6 h-6 mr-3'"
                                    class="flex-none fill-primary-red-dark fill-secondary-red-light"
                                />

                                <div class="flex-grow">
                                    <h1
                                        :class="width > 500 ? 'py-1' : ''"
                                        class="flex-grow mb-3 text-lg font-normal"
                                    >
                                        Unconfirmed Payment
                                    </h1>

                                    <p>......</p>
                                </div>
                            </div>

                            <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                                <base-button
                                    :is-loading="is_saving"
                                    :class="width > 500 ? 'w-auto' : 'w-full'"
                                    class="btn btn-red"
                                    :disabled="payment_intent.charge.state !== 'unconfirmed'"
                                >
                                    Confirm Payment
                                </base-button>
                            </div>
                        </div>
                    </base-form>
                </with-dimensions>

                <details-card :is-open="true">
                    <template slot="header">
                        <h1 class="text-lg font-normal">
                            Payment
                        </h1>

                        <div
                            v-if="is_loading"
                            class="w-6 h-6 mr-3"
                        >
                            <base-svg
                                name="icon-loading"
                                class="w-full h-full"
                            />
                        </div>
                    </template>

                    <template slot="body">
                        <grid-layout>
                            <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs text-label">Subscription</div>
                                <div class="text-sm">
                                    {{ $t(`subscriptions.plans.${payment_intent.charge.subscriptions.data[0].name}`) }}
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs text-label">Amount</div>
                                <div class="text-sm">
                                    {{ payment_intent.charge.amount | money }}
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs text-label">Created</div>
                                <div class="text-sm">
                                    {{ payment_intent.charge.created_at | moment('D MMM YYYY') }}
                                </div>
                            </grid-layout-item>
                        </grid-layout>
                    </template>
                </details-card>

                <modal-success :is-open="show_succeeded_modal">
                    <template slot="heading">Payment successful!</template>

                    <p>
                        Thanks for your payment! We'll send you a confirmation email.
                    </p>

                    <div
                        slot="footer"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <laroute-link
                            :to="{
                                name: 'dashboard.landlord.index'
                            }"
                            class="text-center btn btn-green"
                        >
                            Go to Dashboard
                        </laroute-link>
                    </div>
                </modal-success>

                <modal-error
                    :is-open="show_failed_modal"
                    @close="show_failed_modal = false"
                >
                    <template slot="heading">Payment Failed</template>

                    <p>
                        We were unable to process your payment. We've sent you
                        an email confirming this.
                    </p>

                    <div
                        slot="footer"
                        slot-scope="{ close }"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <button
                            type="button"
                            class="text-center btn btn-red"
                            @click.prevent="close"
                        >
                            Try Again
                        </button>
                    </div>
                </modal-error>
            </div>
        </template>
    </payment-intents-find>
</template>

<script>
    import DetailsCard from '../../../../components/details-card'
    import PaymentIntentsFind from '../../../../components/payment-intents-find'

    export default {
        components: {
            DetailsCard,
            PaymentIntentsFind
        },
        data () {
            return {
                is_saving: false,
                show_succeeded_modal: false,
                show_failed_modal: false
            }
        },
        methods: {
            onSubmit (intent) {
                this.is_saving = true

                this.$stripe.confirmCardPayment(intent.client_secret, {
                    payment_method: intent.payment_method
                })
                    .then(result => {
                        this.is_saving = false

                        if (result.error) {
                            this.show_failed_modal = true
                        } else {
                            this.show_succeeded_modal = true
                        }
                    })
            }
        }
    }
</script>
